import React, { useState } from 'react';

const SupportPage: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const supportEmail = 'support@duguntakibi.com.tr';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const mailto = `mailto:${supportEmail}?subject=${encodeURIComponent(subject || 'Destek Talebi')}&body=${encodeURIComponent(`İsim: ${name}\nE-posta: ${email}\n\n${message}`)}`;
    window.location.href = mailto;
  };

  return (
    <div className="container py-8">
      <div className="row">
        <div className="col-lg-8">
          <div className="card mb-6">
            <div className="card-body">
              <h2 className="mb-3">Support</h2>
              <p>
                Destek için bize e-posta atabilirsiniz: <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
              </p>

              <h4 className="mt-5">İletişim Formu</h4>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">İsim</label>
                  <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <div className="mb-3">
                  <label className="form-label">E-posta</label>
                  <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Konu</label>
                  <input className="form-control" value={subject} onChange={(e) => setSubject(e.target.value)} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Mesaj</label>
                  <textarea className="form-control" rows={6} value={message} onChange={(e) => setMessage(e.target.value)} required />
                </div>
                <button className="btn btn-primary" type="submit">
                  Gönder
                </button>
              </form>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <h4>SSS (Sıkça Sorulan Sorular)</h4>
              <div className="mt-3">
                <h6>1. Hesabımı nasıl oluşturarım?</h6>
                <p>Üst menüden kayıt ol butonuna tıklayarak kayıt formunu doldurabilirsiniz.</p>

                <h6>2. Şifremi unuttum, ne yapmalıyım?</h6>
                <p>Giriş sayfasındaki "Şifremi Unuttum" bağlantısı ile şifre sıfırlama isteği oluşturun.</p>

                <h6>3. Fatura ve siparişlerle ilgili destek nasıl alırım?</h6>
                <p>Lütfen sipariş numaranız ile birlikte yukarıdaki iletişim formunu doldurun veya e-posta gönderin.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="card mb-6">
            <div className="card-body">
              <h5>Hızlı Bilgi</h5>
              <p>
                Destek e-posta adresi: <br />
                <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
              </p>
              <p>Çalışma saatleri: Pazartesi - Cuma, 09:00 - 18:00</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
